module.exports = __webpack_public_path__ + "static/media/loader-gif.7ddc55e3.gif";